var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHiddenInfoArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99947 2.12306L1.97767 7.14486C1.84519 7.27734 1.68921 7.34186 1.50972 7.33844C1.33024 7.33502 1.17426 7.26707 1.04179 7.13459C0.909309 7.00213 0.84307 6.84615 0.84307 6.66666C0.84307 6.48717 0.909309 6.33119 1.04179 6.19873L6.14564 1.08463C6.26615 0.964103 6.40119 0.874787 6.55075 0.816676C6.70033 0.758553 6.8499 0.729492 6.99947 0.729492C7.14904 0.729492 7.29861 0.758553 7.44819 0.816676C7.59775 0.874787 7.73279 0.964103 7.8533 1.08463L12.9674 6.19873C13.0999 6.33119 13.1644 6.48888 13.161 6.67179C13.1576 6.85469 13.0896 7.01238 12.9572 7.14486C12.8247 7.27734 12.6687 7.34358 12.4892 7.34358C12.3097 7.34358 12.1537 7.27734 12.0213 7.14486L6.99947 2.12306Z",
    fill: "#8E8E8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiddenInfoArrow);
export default __webpack_public_path__ + "static/media/hidden-info-arrow.f9dff1aa6af92900a9f9dbab621a2851.svg";
export { ForwardRef as ReactComponent };